module.exports = __webpack_public_path__ + "img/video-y-fotografia-aerea_info.7c765469.jpg";